export const CAROUSEL_SLIDE_WIDTH = 100;
export const CAROUSEL_TRANSITION_DURATION = 300;
export const CAROUSEL_EASING = 'ease-out';
